/*eslint-disable*/
import React, { useEffect, useState } from 'react'
import { Formik, Field as Fieldmik } from 'formik';
import * as yup from 'yup';
import Axios from "axios";
import { DateData } from '../../formikInput/date';
import moment from "moment";
import APP_CONSTANT from '../../../config/constants'
import { Form as FormUi, Container, Button, Label, Modal, Radio, Dropdown,Divider, Header } from 'semantic-ui-react';
import { AllRegex } from '../../../utils/validation';
import { INVALID_MESSAGES, DATE_FORMATS, LOCAL_STORAGE, PROMPTS } from '../../../config/const';
import { MyInput, MyTextArea } from '../../formikInput/input';
import { branchConstants } from './branchConstants'; 
import MyCity from '../../dropdowns/citySearchDropdown';
import ServiceCategoryDropdown from '../../dropdowns/serviceCategoryDropdown';
import cogoToast from "cogo-toast";

const EditBranchModal = ({ handleCloseEdit, updateBranch, branch, ...props }) => {
    const [GSTExempted, setGSTExempted] = useState([])
    let currentYear = new Date().getFullYear()
    let currentMonth = new Date().getMonth()
    let fromYear = currentMonth < 4 ? currentYear - 1 : currentYear
    let toYear = fromYear + 1
    let max_date = new Date(`${currentYear}-12-31`)
    let chargeMechanismOption = [{
        id: 1,
        text: "Forward Charging Mechanism",
        value: "FCM",
        key: 1
    }, {
        id: 2,
        text: "Reverse Charging Mechanism",
        value: "RCM",
        key: 2
    }]
    const initialValues = {
        branchCode: branch.code || "",
        branchName: branch.branchName || "",
        address: branch.address || "",
        pincode: branch.pincode || "",
        panNo : branch.panNo || "",
        cityId: branch.cityId || "",
        cityName : branch.cityName || "",
        stateName : branch.stateName || "",
        GSTExemptedReasonId: branch.isGSTApplicable && branch.isGSTExempted ?  branch.GSTExemptedReasonId:"",
        isGSTApplicable: branch.isGSTApplicable ===1 ? true :false,
        isGSTExempted: branch.isGSTExempted===1 ? true :false,
        gstNo: branch.isGSTApplicable ? branch.gstNo : "",
        validityStartDate: branch.isGSTApplicable  && branch?.gstChargeMechanism && branch.validityStartDate ? new Date(branch.validityStartDate) : "",
        validityEndDate: branch.isGSTApplicable && branch?.gstChargeMechanism && branch.validityEndDate ? new Date(branch.validityEndDate):"",
        gstChargeMechanism :branch.isGSTApplicable ? branch?.gstChargeMechanism : '',
        serviceCategoryId : branch?.serviceCategoryId ? branch.serviceCategoryId : "",
        costCenter :  branch?.costCenter ? branch.costCenter: ""
    };

    const validateSchema = yup.object().shape({
        branchCode: yup.string().nullable().max(15,INVALID_MESSAGES.INVALID_MAXIMUMSIZE(15)),
        branchName: yup.string().required(branchConstants.create.branch_name.error_msg.required).nullable().max(50,INVALID_MESSAGES.INVALID_MAXIMUMSIZE(50)),
        address: yup.string().nullable(),
        pincode: yup.string().optional().nullable().matches(AllRegex.Pincode, INVALID_MESSAGES.INVALID_PINCODE).nullable(),
        panNo: yup.string().optional().nullable().matches(AllRegex.PANIN, INVALID_MESSAGES.INVALID_PAN_NO),
        cityId: yup.string().optional().nullable(),
        stateName: yup.string().optional().nullable(),
        gstNo: yup.string().when('isGSTApplicable', {
            is: (isGSTApplicable) => {
                return isGSTApplicable && isGSTApplicable == true ? true : false
            },
            then: yup.string().required(branchConstants.create.branch_name.error_msg.required).matches(AllRegex.GSTIN, INVALID_MESSAGES.INVALID_GST_NO).nullable(),
            otherwise: yup.string().nullable().optional()
        }),
        serviceCategoryId : yup.string().optional().nullable(),
    costCenter : yup.string().optional().nullable().matches(AllRegex.WITHOUT_SPECIAL_CHARECTERS_AND_SPACE, INVALID_MESSAGES.INVALID_FIELD('Cost Center')),
    });

    const onSubmit = (values, onSubmitProps) => {
        if(values.gstChargeMechanism){
            if(!values.validityStartDate){
                values.validityStartDate = new Date(`04-01-${fromYear} 05:35:32`)
            }
            if(!values.validityEndDate){
                values.validityEndDate = new Date(`03-31-${toYear} 05:35:32`)
            }
        }
        if(branch?.validityStartDate && branch?.validityEndDate && new Date() <  new Date(branch?.validityEndDate)){
            let isGSTApplicable = branch.isGSTApplicable ===1 ? true :false
            let isGSTExempted = branch.isGSTExempted===1 ? true :false
            if(isGSTApplicable !== values.isGSTApplicable){
                cogoToast.error(PROMPTS.CANT_CHANGE_IN_CURRENT_FINANCIAL_YEAR('Is GST Applicable value'), { position: 'top-right' })
                setTimeout(() => { onSubmitProps.setSubmitting(false) }, 4000)
                return ;
            }
            if(branch?.gstChargeMechanism !== values.gstChargeMechanism){
                cogoToast.error(PROMPTS.CANT_CHANGE_IN_CURRENT_FINANCIAL_YEAR('GST Charge Mechanism'), { position: 'top-right' })
                setTimeout(() => { onSubmitProps.setSubmitting(false) }, 4000)
                return ;
            }
            if(isGSTExempted !== values.isGSTExempted){
                cogoToast.error(PROMPTS.CANT_CHANGE_IN_CURRENT_FINANCIAL_YEAR('Is GST Exempted value'), { position: 'top-right' })
                setTimeout(() => { onSubmitProps.setSubmitting(false) }, 4000)
                return ;
            }
          }
        const { userId, customerNo, userToken } = LOCAL_STORAGE;
        const branchData = {
            ...values,
            branchCode: values.branchCode,
            branchName: values.branchName,
            address: values.address,
            pincode: values.pincode,
            panNo : values.panNo,
            cityId: values.cityId,
            stateName : values.stateName,
            isGSTApplicable: values.isGSTApplicable,
            isGSTExempted: values.isGSTExempted,
            gstNo: values.gstNo,
            gstChargeMechanism:values.gstChargeMechanism,
            GSTExemptedReasonId: values.GSTExemptedReasonId,
            validityStartDate: values.validityStartDate ? moment(values.validityStartDate).format(DATE_FORMATS.YYYY_MM_DD) : null,
            validityEndDate: values.validityEndDate ? moment(values.validityEndDate).format(DATE_FORMATS.YYYY_MM_DD) : null,
            customerNumber: customerNo,
            userId: userId,
        }
        updateBranch(branchData, branch.branchId).then(() => {
            setTimeout(() => { onSubmitProps.setSubmitting(false) }, 4000)
        });

    };

    useEffect(async () => {
        const { userId, customerNo, userToken } = LOCAL_STORAGE;

        const headerData = {
            "customerNumber": customerNo,
            "userId": userId,
        }
        const { data } = await Axios.post(`${APP_CONSTANT.BASE_URL}/masters/gstExemptedReason`, headerData, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": userToken,
                "Access-Control-Allow-Origin": "*",
            }
        });
        const options = data?.resultSet.map(({ GSTExemptedReasonId, GSTExemptedReasonName }) => {
            return {
                id: GSTExemptedReasonId,
                text: GSTExemptedReasonName,
                value: GSTExemptedReasonId,
                key: GSTExemptedReasonId
            }
        }
        )
        setGSTExempted(options)
    }, [])

    return (
        <>
            <Formik
                initialValues={initialValues}
                validationSchema={validateSchema}
                onSubmit={onSubmit}
            >
                {({ values, isSubmitting, errors, touched, handleSubmit, setFieldValue }) => (
                    <>
                        <Modal.Content>
                            <Container>
                                <div className="ui form tiny">
                                    <FormUi.Group>
                                    <FormUi.Field width="2">
                                        <label className="labelName p-bold-600">{branchConstants?.create?.branch_code?.title||"Branch Code"}</label>
                                        </FormUi.Field>
                                        <FormUi.Field width="4">
                                        <Fieldmik name="branchCode" component={MyInput} error={values.branchCode ? false : true} placeholder={branchConstants?.create?.branch_code?.placeholder||"Code"} readOnly={true} />
                                        {touched.branchCode && errors.branchCode ? <Label size="mini" prompt pointing>{errors.branchCode}</Label> : ''}
                                    </FormUi.Field>
                                    <FormUi.Field width="2"/>
                                    <FormUi.Field width="2">
                                        <label className="labelName p-bold-600">{branchConstants?.create?.branch_name?.title||"Branch Name"} *</label>
                                        </FormUi.Field>
                                        <FormUi.Field width="4">
                                        <Fieldmik name="branchName" component={MyInput} error={values.branchName ? false : true} placeholder={branchConstants?.create?.branch_name?.placeholder||"Name"} />
                                        {touched.branchName && errors.branchName ? <Label size="mini" prompt pointing>{errors.branchName}</Label> : ''}
                                    </FormUi.Field>
                                    </FormUi.Group>

                                    <FormUi.Group>
                                    <FormUi.Field width="2">
                                        <label className="labelName p-bold-600">{branchConstants?.create?.pincode?.title||"Pincode"}</label>
                                        </FormUi.Field>
                                        <FormUi.Field width="4">
                                        <Fieldmik name="pincode" component={MyInput} error={errors.pincode ? true : false} placeholder={branchConstants?.create?.pincode?.placeholder||"Pincode"} />
                                        {touched.pincode && errors.pincode ? <Label size="mini" prompt pointing>{errors.pincode}</Label> : ''}
                                    </FormUi.Field>
                                    <FormUi.Field width="2"/>
                                    <FormUi.Field width="2">
                                        <label className="labelName p-bold-600">{branchConstants?.create?.pan_no?.title||"PAN Number"}</label>
                                        </FormUi.Field>
                                        <FormUi.Field width="4">
                                        <Fieldmik name="panNo" component={MyInput} error={errors.panNo ? true : false} placeholder={branchConstants?.create?.pan_no?.placeholder||"Pan Number"} readOnly={branch?.panNo ? true :false} />
                                        {touched.panNo && errors.panNo ? <Label size="mini" prompt pointing>{errors.panNo}</Label> : ''}
                                    </FormUi.Field>
                                    </FormUi.Group>

                                    <FormUi.Group>
                                    <FormUi.Field width="2">
                                        <label className="labelName p-bold-600">{branchConstants?.create?.city?.title||"City"}</label>
                                        </FormUi.Field>
                                        <FormUi.Field width="4">
                                        <Fieldmik name="cityId" component={MyCity} error={errors.cityId ? true : false} placeholder={values.cityName||branchConstants?.create?.city?.placeholder||"City"} stateName="stateName" className="p-placeholder"
                                        stateFilterId={branch?.stateId ? branch?.stateId : false} />
                                        {touched.cityId && errors.cityId ? <Label size="mini" prompt pointing>{errors.cityId}</Label> : ''}
                                    </FormUi.Field>
                                    <FormUi.Field width="2"/>
                                    <FormUi.Field width="2">
                                        <label className="labelName p-bold-600">{branchConstants?.create?.state?.title||"State"}</label>
                                        </FormUi.Field>
                                        <FormUi.Field width="4">
                                        <Fieldmik name="stateName" component={MyInput} error={errors.pincode ? true : false} placeholder={branchConstants?.create?.state?.name_placeholder||"State Name"} readOnly={true}/>
                                        {touched.stateName && errors.stateName ? <Label size="mini" prompt pointing>{errors.stateName}</Label> : ''}
                                    </FormUi.Field>
                                    </FormUi.Group>

                                    <FormUi.Group>
                                    <FormUi.Field width="2">
                                        <label className="labelName p-bold-600">{branchConstants?.create?.address?.title||"Address"}</label>
                                        </FormUi.Field>
                                        <FormUi.Field width="4">
                                        <Fieldmik name="address" component={MyTextArea} error={false} placeholder={branchConstants?.create?.address?.placeholder||"Address"} />
                                    </FormUi.Field>
                                    </FormUi.Group>
                               

                                    <Divider horizontal>
                                            <Header as='h4'>
                                                {branchConstants?.create?.gst_title}
                                            </Header>
                                        </Divider>

                                    <FormUi.Group>
                                    <FormUi.Field width="2">
                                        <label className="labelName mt-2">{branchConstants?.create?.is_gst_applicable?.title||"Is GST Applicable"}</label>
                                    </FormUi.Field>
                                    <FormUi.Field width="4">
                                        <Radio label="No" className='mt-2' name='isGSTApplicable' 
                                            checked={values?.isGSTApplicable == false ? true : false} onChange={() => { setFieldValue("isGSTApplicable", false) }} />
                                        &nbsp;&nbsp;&nbsp;<Radio label="Yes" className='mt-2 mr-4' name='isGSTApplicable' value='Yes'
                                            checked={values?.isGSTApplicable == true ? true : false} onChange={() => { setFieldValue("isGSTApplicable", true) }} />
                                    </FormUi.Field>
                                    <FormUi.Field width="2"/>
                                    {
                                        values.isGSTApplicable ?
                                            <>
                                                <FormUi.Field width="2">
                                                    <label className="labelName p-bold-600">{branchConstants?.create?.gst_no?.title||"Gst Number"}</label>
                                                </FormUi.Field>
                                                <FormUi.Field width="4">
                                                    <Fieldmik style={{ width: "100%" }} name="gstNo" component={MyInput} error={errors.gstNo != '' ? true : false}
                                                        placeholder={branchConstants?.create?.gst_no?.placeholder||"GST Number"} readOnly={branch?.gstNo ? true : false}/>
                                                    {touched.gstNo && errors.gstNo ? <Label size="mini" prompt pointing>{errors.gstNo}</Label> : ''}
                                                </FormUi.Field>
                                            </>:null }
                                                
                                    </FormUi.Group>
                                    {
                                        values.isGSTApplicable ?
                                            <>
                                            <FormUi.Group>
                                         <FormUi.Field width="2">
                                                <label>{branchConstants?.create?.charge_mechanism?.title||"Charge Mechanism"} </label>
                                                </FormUi.Field>
                                                <FormUi.Field width="4">
                                                <Dropdown
                                                    name="gstChargeMechanism"
                                                    clearable
                                                    style={{ width: "100%", fontWeight: "normal" }}
                                                    selection
                                                    placeholder={branchConstants?.create?.charge_mechanism?.placeholder}
                                                    value={values.gstChargeMechanism}
                                                    options={chargeMechanismOption}
                                                    onChange={(name, data) => {
                                                        setFieldValue("gstChargeMechanism", data.value);
                                                    }}
                                                />
                                                </FormUi.Field>
                                          </FormUi.Group>

                                            <FormUi.Group>
                                                <FormUi.Field width="2">
                                                    <label>{branchConstants?.create?.start_date?.title||"Validity Start Date"}</label>
                                                </FormUi.Field>
                                                <FormUi.Field width="4" >
                                                    <DateData
                                                        name={`validityStartDate`}
                                                        autoComplete="off"
                                                        popperClassName="dateTime"
                                                        dateFormat={DATE_FORMATS.dd_MM_yyyy}
                                                        placeholderText="Validity Start Date"
                                                        customInput={<FormUi.Input style={{ width: "120%" }}
                                                            autoComplete="off" className="dateWidth" icon="time" iconPosition="left" />
                                                        }
                                                        maxDate={new Date(values.validityEndDate).getFullYear() == currentYear ?values.validityEndDate: max_date}
                                                    />
                                                </FormUi.Field>
                                                <FormUi.Field width="2"/>
                                                <FormUi.Field width="2">
                                                    <label>{branchConstants?.create?.end_date?.title||"Validity End Date"}</label>
                                                </FormUi.Field>
                                                <FormUi.Field width="4">
                                                <DateData
                                                    name={`validityEndDate`}
                                                    autoComplete="off"
                                                    style={{ width: "100%" }}
                                                    popperClassName="dateTime"
                                                    minDate={values.validityStartDate}
                                                    dateFormat={DATE_FORMATS.dd_MM_yyyy}
                                                    placeholderText="Validity End Date"
                                                    customInput={<FormUi.Input style={{ width: "120%" }}
                                                        autoComplete="off" className="dateWidth" icon="time" iconPosition="left" />
                                                    }
                                                />
                                                </FormUi.Field>
                                                </FormUi.Group>
                                           
                            
                                    <FormUi.Group>
                                    <FormUi.Field width="2">
                                        <label className="labelName mt-2">{branchConstants?.create?.is_gst_exempted?.title||"Is GST Exempted"}</label>
                                    </FormUi.Field>
                                    <FormUi.Field width="4">
                                        <Radio label="No" className='mt-2' name='isGSTExempted' value={values.isGSTExempted}
                                            checked={values.isGSTExempted == false ? true : false}
                                            onChange={() => { setFieldValue("isGSTExempted", !values.isGSTExempted) }} />
                                        &nbsp;&nbsp;&nbsp;<Radio label="Yes" className='mt-2 mr-4' name='isGSTExempted' value='Yes'
                                            checked={values.isGSTExempted == true ? true : false}
                                            onChange={() => { setFieldValue("isGSTExempted", !values.isGSTExempted) }} />
                                    </FormUi.Field>

                                    <FormUi.Field width="2" />
                                    {
                                        values.isGSTExempted ?
                                            <>
                                                <FormUi.Field width="2">
                                                    <label>{branchConstants?.create?.exempted_reason?.title||"Gst Exempted Reason"}</label>
                                                </FormUi.Field>
                                                <FormUi.Field width="4">
                                                    <Dropdown
                                                        name="GSTExemptedReasonId"
                                                        clearable
                                                        style={{ width: "100%", fontWeight: "normal" }}
                                                        selection
                                                        placeholder={branchConstants?.create?.exempted_reason?.placeholder||"--SELECT A REASON--"}
                                                        value={values.GSTExemptedReasonId}
                                                        options={GSTExempted}
                                                        onChange={(name, data) => {
                                                            setFieldValue("GSTExemptedReasonId", data.value);
                                                        }}
                                                    />
                                                </FormUi.Field></> : null
                                    }
                                    </FormUi.Group>
                                     </> : null
                                    }

                                        <Divider horizontal>
                                            <Header as='h4'>
                                                {branchConstants?.create?.service_category_title||"Service Category Details"}
                                            </Header>
                                        </Divider>
                                        <FormUi.Group>
                                    <FormUi.Field width="2">
                                        <label className="labelName p-bold-600">{branchConstants?.create?.service_category?.title || "Service Category"}</label>
                                    </FormUi.Field>
                                    <FormUi.Field width="4">
                                        <Fieldmik name="serviceCategoryId" component={ServiceCategoryDropdown} placeholder={branchConstants?.create?.service_category?.placeholder} value={values.serviceCategoryId} disabled={branch?.serviceCategoryId ? true : false} />
                                        {touched.serviceCategoryId && errors.serviceCategoryId ? <Label size="mini" prompt pointing>{errors.serviceCategoryId}</Label> : ''}
                                        </FormUi.Field>
                                        <FormUi.Field width="2"/>
                                        <FormUi.Field width="2">
                                        <label className="labelName p-bold-600">{branchConstants?.create?.cost_center?.title || "Cost Center"}</label>
                                        </FormUi.Field>
                                        <FormUi.Field width="4">
                                        <Fieldmik name="costCenter" component={MyInput} placeholder={branchConstants?.create?.cost_center?.placeholder} />
                                        {touched.costCenter && errors.costCenter ? <Label size="mini" prompt pointing>{errors.costCenter}</Label> : ''}
                                    </FormUi.Field>
                                    </FormUi.Group>

                              </div>
                            </Container>
                        </Modal.Content>
                        <Modal.Actions>
                            <Button onClick={handleCloseEdit} size="mini">{branchConstants?.create?.action_button?.cancel||"Cancel"}</Button>
                            <Button disabled={isSubmitting} type="submit" onClick={handleSubmit} size="mini" primary>{branchConstants?.create?.action_button?.submit||"Submit"}</Button>
                        </Modal.Actions>
                    </>
                )}
            </Formik>
        </>
    )
}


export default EditBranchModal
